(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[247],{

/***/ 7414:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anlaggningar",
      function () {
        return __webpack_require__(1047);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8527);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3244);
/* harmony import */ var helpers_discounts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2940);






var CampaignBanner = function(param) {
    var campaigns = param.campaigns, campaignLevel = param.campaignLevel, id = param.id, title = param.title;
    var filteredCampaign = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(campaign) {
        return campaign.isActive;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), activeCampaigns = ref[0], setActiveCampaigns = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), activeDiscounts = ref1[0], setActiveDiscounts = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), discountIndex = ref2[0], setDiscountIndex = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var sortedCampaigns = [];
        if (campaignLevel === "Top") {
            sortedCampaigns = filteredCampaign === null || filteredCampaign === void 0 ? void 0 : filteredCampaign.filter(function(campaign) {
                return campaign.appliesToAll;
            });
        } else if (campaignLevel === "Facility") {
            sortedCampaigns = filteredCampaign === null || filteredCampaign === void 0 ? void 0 : filteredCampaign.filter(function(campaign) {
                return campaign.appliesToFacilityId.includes(id);
            });
        }
        setActiveCampaigns(sortedCampaigns);
    }, [
        id
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.forEach(function(campaign) {
            if (campaign.discounts.length > 0) {
                setActiveDiscounts((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(activeDiscounts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(campaign.discounts)));
            }
        });
    }, [
        activeCampaigns
    ]);
    var titleText = function(discount) {
        var titleText = "JUST NU:";
        if (discount !== undefined) {
            if (campaignLevel === "Facility" && title) {
                titleText = "JUST NU i ".concat(title.toLocaleUpperCase(), " p\xe5 utvalda f\xf6rr\xe5d:");
            }
        }
        return titleText;
    };
    console.log({
        activeCampaigns: activeCampaigns
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.length) > 0 && activeDiscounts.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
            py: 3,
            backgroundColor: constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .colors.system.error[900] */ .O9.system.error[900],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                color: constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .colors.white */ .O9.white,
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                        fontWeight: 600,
                        mr: 3,
                        children: titleText(activeDiscounts[discountIndex])
                    }),
                    " ",
                    (0,helpers_discounts__WEBPACK_IMPORTED_MODULE_5__/* .discountText */ .LT)(activeDiscounts[discountIndex])
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CampaignBanner);


/***/ }),

/***/ 2940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LT": function() { return /* binding */ discountText; },
/* harmony export */   "lk": function() { return /* binding */ getDiscountPrice; },
/* harmony export */   "vN": function() { return /* binding */ getBestDiscount; }
/* harmony export */ });
/* unused harmony export checkAvailbleDiscounts */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);

var checkAvailbleDiscounts = function(campaigns, campaignLevel, facilityId, unitId) {
    var activeCampaigns = [];
    var activeDiscounts = [];
    if (campaignLevel === "Top") {
        activeCampaigns = campaigns.filter(function(campaign) {
            return campaign.appliesToAll;
        });
    } else if (campaignLevel === "Facility") {
        activeCampaigns = campaigns.filter(function(campaign) {
            return campaign.appliesToFacilityId.includes(facilityId);
        });
    } else if (campaignLevel === "Unit") {
        activeCampaigns = campaigns.filter(function(campaign) {
            return campaign.appliesToAll || campaign.appliesToFacilityId.includes(facilityId);
        });
    }
    if (campaignLevel === "Unit") {
        activeCampaigns.forEach(function(campaign) {
            return activeDiscounts = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(activeDiscounts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(campaign.discounts.filter(function(discount) {
                return discount.appliesToAll || discount.appliesToProductId.includes(unitId);
            })));
        });
    } else {
        activeCampaigns.forEach(function(campaign) {
            return activeDiscounts = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(activeDiscounts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(campaign.discounts));
        });
    }
    return activeDiscounts;
};
var calcuteDiscountedPrice = function(price, discount) {
    return discount.discountType === "fixed" ? price - discount.amountOff : price * (1 - discount.percentOff / 100);
};
var getDiscountPrice = function(price, discount) {
    var returnPrice = price;
    var discountPrice = calcuteDiscountedPrice(price, discount);
    if (discountPrice < returnPrice) {
        returnPrice = discountPrice > 0 ? discountPrice : 0;
    }
    return Math.round(returnPrice * 100) / 100;
};
var getBestDiscount = function(price, discounts) {
    var returnDiscount;
    discounts.forEach(function(discount) {
        if (returnDiscount === undefined) {
            returnDiscount = discount;
        } else {
            var currentDiscountPrice = calcuteDiscountedPrice(price, returnDiscount);
            if (currentDiscountPrice > calcuteDiscountedPrice(price, discount)) {
                returnDiscount = discount;
            }
        }
    });
    return returnDiscount;
};
var discountText = function(discount) {
    if (discount !== undefined) {
        var val = "kr";
        if (discount.discountType === "percent") {
            val = "%";
        }
        var length = "under din f\xf6rsta m\xe5nad";
        if (!discount.includeFirstMonth) {
            length = "under din f\xf6rsta hela m\xe5nad";
        }
        if (discount.discountedMonths > 0) {
            length = "under ".concat(discount.discountedMonths, " m\xe5nader");
        }
        var condition = "";
        if (discount.requireFirstOrder) {
            condition = ", g\xe4ller endast nya kunder";
        }
        return "".concat(discount.discountType === "percent" ? discount.discountValue : discount.amountOff).concat(val, " rabatt ").concat(length).concat(condition, ".");
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (checkAvailbleDiscounts);


/***/ }),

/***/ 1047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ anlaggningar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/chakra-ui-select.esm.js
var chakra_ui_select_esm = __webpack_require__(1391);
// EXTERNAL MODULE: ./constants/constants.tsx
var constants = __webpack_require__(3244);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(9876);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(5193);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/unit/UnitCard.tsx







var UnitCard = function(param) {
    var facility = param.facility;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        style: {
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "4px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                zIndex: 2,
                position: "relative",
                style: {
                    aspectRatio: "16/10"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    src: facility.image.url
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                style: {
                    padding: "26px 20px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        mb: 3,
                        color: constants/* colors.secondary.darkGrey */.O9.secondary.darkGrey,
                        fontWeight: 600,
                        fontSize: 24,
                        children: facility.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        children: facility.address.split(",")[0]
                    }),
                    facility.address.split(",").length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        mb: 5,
                        children: facility.address.split(",")[1]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: facility.url.replace("/website/anlaggningar", "/anlaggning"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_button_esm/* Button */.zx, {
                            variant: "ml",
                            size: "lg",
                            paddingX: 10,
                            fontWeight: "400",
                            children: [
                                "Boka",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ChevronRightIcon */.XC, {
                                    ml: 3
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var unit_UnitCard = (UnitCard);

// EXTERNAL MODULE: ./components/campaigns/CampaignBanner.tsx
var CampaignBanner = __webpack_require__(9841);
;// CONCATENATED MODULE: ./pages/anlaggningar/index.tsx







var UnitsPage = function(param) {
    var facilities = param.facilities, sharedPageProps = param.sharedPageProps, content = param.content;
    var ref;
    var ref1 = (0,react.useState)(""), activeFacility = ref1[0], setActiveFacility = ref1[1];
    var namesToMatch = (ref = sharedPageProps.facilities) === null || ref === void 0 ? void 0 : ref.map(function(facility) {
        return facility.name;
    });
    console.log(facilities, "facilities");
    // Getting array of unique name string, set are not liked by TS, hence the weird array.from[..Set]
    var locations = (0,_to_consumable_array/* default */.Z)(Array.from(new Set(sharedPageProps.facilities.map(function(x) {
        return x.location.name;
    })))).filter(function(v, i, a) {
        return a.indexOf(v) === i;
    });
    var filteredFacilities = facilities.filter(function(y) {
        return namesToMatch.includes(y.name);
    }).filter(function(x) {
        return activeFacility.length > 0 ? x.name.split(" ")[0] === activeFacility : x;
    });
    console.log(sharedPageProps);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBanner/* default */.Z, {
                campaigns: sharedPageProps.campaigns,
                campaignLevel: "Top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                p: constants/* blockPadding */.$1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                        templateColumns: {
                            base: "1fr",
                            md: "4fr 8fr"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* GridItem */.P4, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                        as: "h1",
                                        fontSize: "xl",
                                        fontWeight: "600",
                                        mb: 5,
                                        children: content.header
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                        dangerouslySetInnerHTML: {
                                            __html: content.rteText
                                        },
                                        fontSize: 14,
                                        fontWeight: "400",
                                        mb: 5,
                                        pr: 5
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                        w: 300,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_select_esm/* Select */.Ph, {
                                            onChange: function(e) {
                                                return setActiveFacility(e.target.value);
                                            },
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "",
                                                    children: "Alla st\xe4der"
                                                }),
                                                locations.map(function(location) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        style: {
                                                            borderRight: "1px solid black"
                                                        },
                                                        value: location,
                                                        children: location
                                                    }, location);
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                                    columns: 2,
                                    spacing: 10,
                                    children: filteredFacilities.map(function(facility) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_UnitCard, {
                                            facility: facility
                                        }, facility.id);
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var anlaggningar = (UnitsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(7414); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);